export class Step {
  id?: number;
  label: string = '';
  no?: string;
  value: string = '';
  expanded?: boolean;
  children?: Step[];
  formId?: number;
  formData?: any;
  generatedCode?: any;
  codeGenerated?: boolean;
  visited?: boolean;
  button?: string;
  pending?: any;
  disabled?: boolean = false;
  noSaveAdd?: boolean = false;
  type?: string;
  disableParentClick?: boolean = false;
  hasChanges?: boolean = false;
}

export class BtnConfig {
  key: string = '';
  showOn: 'checked' | 'unchecked' = 'unchecked';
  isPrimary: boolean = false;
  label: string = '';
  disabled?: boolean = false;
  sequence: number = 0;
  hide?: boolean = false;
}

export class ImportConfig {
  moduleName: string = ''; //eg. User Profile, Entity Profile
  singleType: string = ''; //eg. user, entity
  pluralType: string = ''; //eg. users, entities
  desc?: string = ''; //eg. "Download the template and add multiple users at once by importing the completed file."
  allowedFileTypes: string = ''; //eg. ".csv, .xlsx"
  maxFiles: number = 1; //eg. 5
  maxFileSize: number = 10; //in MB. eg. 10
  allowedFileTypesLabel?: string = '';
  uploadFileTypesLabel?: string = '';
}

export class FilterFieldConfig {
  label!: string;
  value!: string;
  type?: 'dropdown' | 'selection' | 'toggle' | 'date' = 'dropdown';
  reverse?: boolean = false;
  matchType?: number = 0;
  dataType?: number;
  customToggleLabel?: string;
  customOnToggleLabel?: string;
  customOffToggleLabel?: string;
  onValue?: string = 'true';
  offValue?: string = 'false';
  dependent?: FilterDependentConfig;
  displayKey?: string = 'description';
  hide?: boolean = false;
}

export class FilterDependentConfig {
  label: string = '';
  value!: string;
  type?: 'dropdown' | 'selection' = 'dropdown';
  displayKey?: string = 'description';
  matchType?: number = 0;
  dataType?: number = 0;
}

export class InfoDetail {
  icon: string = '';
  label: string = '';
}

export class ValueDetail {
  isList: boolean = false;
  value: string = '';
  valueList: string[] = [];
}

export class ListingDetail {
  oldValue: ValueDetail = new ValueDetail();
  newValue: ValueDetail = new ValueDetail();
  [key: string]: any; // allow anything else
}

export class Detail {
  id: number = 0;
  name: string = '';
  code: string = '';
  status: string = '';
  imgSrc: string = '';
  tags: string[] = [];
  checked: boolean = false;
  // infoDetails: string[] = [];
  infoDetails: InfoDetail[] = [];
  listingDetails: ListingDetail[] = [];
}

export class DialogTableAddDelete {
  originalList: number[] = [];
  addList: number[] = [];
  removeList: number[] = [];
  clearAll: boolean = false;
}

//#region Upload Files
export class UploadConfig {
  desc?: string = ''; //eg. "Drop files here or Click to upload"
  maxFilesReachedDesc?: string = ''; //eg. "Max file count reached."
  mimeMap?: Record<string, string> = {};
  allowedFileTypes: string = '.pdf,.jpg,.png,.doc,.jpeg,.gif'; //eg. ".csv,.xlsx"
  allowedFileTypesLabel: string = '*.jpeg, *.jpg, *.png, *.gif, *.pdf, *.doc';
  maxFiles: number = 10; //eg. 10
  maxFileSizeInMB: number = 10; //in MB. eg. 10
  maxFileSizeInBytes?: number = 0; //in bytes. eg. 10485760
}
